import { render, staticRenderFns } from "./OrgSummaryPanel.vue?vue&type=template&id=7c396572&scoped=true"
import script from "./OrgSummaryPanel.vue?vue&type=script&lang=js"
export * from "./OrgSummaryPanel.vue?vue&type=script&lang=js"
import style0 from "./OrgSummaryPanel.vue?vue&type=style&index=0&id=7c396572&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c396572",
  null
  
)

export default component.exports